<template>
  <section>
    <div class="layout1">
      <div>
        <span>{{ title }}</span>
        <span>
          <el-pagination
            class="fun-pagination"
            layout="prev, next"
            :total="total"
            :current-page="page"
            @current-change="handleCurrentChange"
          />
        </span>
      </div>
      <div>
        <el-button
          v-for="(item, index) in list"
          :key="index"
          type="text"
          :disabled="item.category_id===category_id"
          @click="handleRoute(item)"
        >
          <span class="layout1Btn">
            <span>
              <span :style="{ width: basicWidth,color:item.category_id===category_id?'#2362FB':'#777' }">{{ item.name }}</span>
              <span v-if="basicType == '1'">{{ item.num }}阅读</span>
              <span v-if="basicType == '2'">相关文档约{{ item.num }}篇</span>
            </span>
            <span>
              <img v-if="item.img" :src="item.img" alt="">
            </span>
          </span>
        </el-button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComLayout1',
  components: {},
  props: {
    title: {
      type: String,
      default: '标题1'
    },
    basicWidth: {
      type: String,
      default: '270px'
    },
    basicType: {
      type: String,
      default: '1'
    },
    total: {
      type: Number,
      default: 100
    },
    page: {
      type: Number,
      default: 1
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    category_id() {
      return this.$route.query.category || ''
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    handleCurrentChange(v) {
      this.$emit('currentChange', v)
    },
    handleRoute(v) {
      this.$router.push({
        path: '/notes/standard',
        query: {
          category: v.category_id,
          name: v.name
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.fun-pagination{
  @include fun-pagination()
}
.layout1 {
  background-color: #fff;
  padding: 18px 22px 18px 28px;
  border-radius: 6px;
  > div {
    &:nth-child(1) {
      height: 33px;
      line-height: 33px;
      @include fun-border(0,"bottom");
      display: flex;
      justify-content: space-between;
      width: 100%;
      > span {
        &:nth-child(1) {
          display: block;
          width: 60%;
          font-family: "AdobeHeitiStd-Regular";
          @include fun-design(10);
        }
      }
    }
    &:nth-child(2) {
      display: flex;
      flex-direction: column;
      > button {
        padding: 10px 1px 12px 3px;
        display: flex;
        margin-left: 0;
        .layout1Btn {
          display: flex;
          justify-content: space-between;
          > span {
            &:nth-child(1) {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              > span {
                text-align: left;
                &:nth-child(1) {
                  font-family: "AdobeHeitiStd-Regular";
                  @include fun-design(10);
                  @include obj-clamp1()
                }
                &:nth-child(2) {
                  font-family: "AdobeHeitiStd-Regular";
                  font-size: 10px;
                  color: #b9b9b9;
                }
              }
            }
            &:nth-child(2) {
              height: 48px;
              width: 40px;
              > img {
                width: 40px;
                height: 48px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang='scss' scoped>
.layout1 /deep/.el-pagination button:disabled {
  background-color: #fff;
}
</style>
